// extracted by mini-css-extract-plugin
module.exports = {"profilePage":"Profile_profilePage__2lmjL"};